import React from 'react';
import { Loader2 } from 'lucide-react';
import { useInflightAnalysis } from '@/hooks/useInflightAnalysis';

type InflightAnalysisIndicatorProps = {
  onFinished?: () => void;
};

function InflightAnalysisIndicator({ onFinished }: InflightAnalysisIndicatorProps) {
  const { inflight, openWorkflow } = useInflightAnalysis(onFinished);

  if (!inflight) return null;

  return (
    <button
      type="button"
      onClick={openWorkflow}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-lg border border-amber-500/40 bg-[#141414]/95 px-4 py-3 shadow-lg backdrop-blur-sm hover:border-amber-500/70 hover:bg-[#1a1a1a] transition-colors text-left max-w-xs"
    >
      <Loader2 className="h-4 w-4 shrink-0 animate-spin text-amber-400" />
      <span className="text-sm font-sans text-white/90 leading-snug">
        Inflight analysis for{' '}
        <span className="text-gold-button font-medium">{inflight.scriptTitle}</span>
      </span>
    </button>
  );
}

export default InflightAnalysisIndicator;
